import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Tab = styled.li`
  font-family: 'Lato', sans-serif;
  font-size: 2em;
  font-style: normal;
  font-weight: 700;
  list-style-type: none;
  padding: 25px;
  margin-right: 40px;
  &:hover {
    color: ${props => props.theme.color.primary};
    cursor: pointer;
  }
  ${props =>
    props.onDisplay
      ? `color: ${props.theme.color.primary};
      border-bottom: 7px solid ${props.theme.color.primary};
      `
      : `color: black;
      border-bottom: none;
  `};
`;

const Tabs = ({ index, name, selectCatagory, onDisplay }) => {
  return (
    <Tab onDisplay={onDisplay} onClick={e => selectCatagory(e, index)}>
      {name}
    </Tab>
  );
};

Tabs.propTypes = {
  index: PropTypes.number,
  name: PropTypes.string,
  onDisplay: PropTypes.bool,
  selectCatagory: PropTypes.func
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/Tabs/index.js